module.exports = __webpack_public_path__ + "media/images/app/products/shipping-bag-orange-70b657630546f6161c95759171106607.svg";